import { graphql } from "@opensea/graphql"
import { ChainBadgeFragment } from "../ChainBadge/ChainBadge.fragment"
import { NewCurrencyChipFragment } from "../NewCurrencyChip/NewCurrencyChip.fragment"

export const CurrencyLockupFragment = graphql(
  `
    fragment CurrencyLockup on Currency {
      name
      symbol
      imageUrl
      chain {
        ...ChainBadge
      }
      metadata {
        fullCollection {
          imageUrl
        }
      }
      ...NewCurrencyChip
    }
  `,
  [ChainBadgeFragment, NewCurrencyChipFragment],
)
